import { Location } from '@angular/common';
import { Router, ActivationEnd } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import AngularStateHelperService from '../services/angular-state-helper.service';

@Injectable({ providedIn: 'root' })
export default class AngularRoutingHelperService {
	private angularStateHelperService: AngularStateHelperService = inject(AngularStateHelperService);
	private router: Router = inject(Router);
	private location: Location = inject(Location);
	
	routeSubs: any = null;
	curRoute: any = null;
	routeSnapshot: any = null;
	routeParams: any = null;
	routeQueryParams: any = null;
	
	constructor() {
		if (!this.routeSubs) {
			this.routeSubs = this.router.events.subscribe((event: any) => {
				if (event instanceof ActivationEnd) {
					if (this.curRoute != event.snapshot.routeConfig.path) {
						this.routeSnapshot = event.snapshot;
						this.curRoute = event.snapshot.routeConfig.path;
						this.routeParams = this.routeSnapshot.params;
						this.routeQueryParams = this.routeSnapshot.queryParams;

						var routeConfig = this.getCurrentRouteConfig(this.curRoute);
						if (routeConfig) {
							this.angularStateHelperService.updateRouteViewStates(routeConfig.config);
						}
					} else {
						if (this.routeParams || (event.snapshot && event.snapshot.params)) {
							this.routeParams = event.snapshot.params;
						}
						if (this.routeQueryParams || (event.snapshot && event.snapshot.queryParams)) {
							this.routeQueryParams = event.snapshot.queryParams;
						}
					}
				}
			});
		}
	}
	
	initRoutingConfig() {
		this.setCurrentRouteConfig('booking/service/:serviceId/address', { reloadOnSearch: false });
		this.setCurrentRouteConfig('booking/service/:serviceId/checkout', { reloadOnSearch: false, backButton: true });
		this.setCurrentRouteConfig('booking/offer/:bookingOfferId/checkout', { reloadOnSearch: false, backButton: true });
		this.setCurrentRouteConfig('booking/instant/checkout', { reloadOnSearch: false, backButton: true });
		this.setCurrentRouteConfig('booking/prescription/checkout', { reloadOnSearch: false, backButton: true });
		this.setCurrentRouteConfig('booking/instant', { backButton: true });
		this.setCurrentRouteConfig('booking/intermediate-dialog', { reloadOnSearch: false });
		this.setCurrentRouteConfig('booking/mental-check', { backButton: true });
		this.setCurrentRouteConfig('booking/mental-check-unavailable', { backButton: true });
		this.setCurrentRouteConfig('booking/:reservationId/reservation', { reloadOnSearch: false });
		this.setCurrentRouteConfig('booking/service/:serviceId', { reloadOnSearch: false });
		this.setCurrentRouteConfig('mental-health-services', { backButton: true });
		this.setCurrentRouteConfig('bookings/:type', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('bookings', { showProfileHeader: true, hideFooter: true });
		this.setCurrentRouteConfig('call', { hasBgImage: true, hasNoScroll: true, hideFooter: true, isFullScreen: true });
		this.setCurrentRouteConfig('chats/:id', { reloadOnSearch: false, noOffsetBottom: true, backButton: true });
		this.setCurrentRouteConfig('chatbot/:serviceId', { reloadOnSearch: false, backButton: true });
		this.setCurrentRouteConfig('chats', { reloadOnSearch: false, noOffsetBottom: true });
		this.setCurrentRouteConfig('pre-visit-chat/:id', { isNoHeader: true });
		this.setCurrentRouteConfig('xroad/consent-service', { reloadOnSearch: false, backButton: true });
		this.setCurrentRouteConfig('xroad/consents', { reloadOnSearch: false, backButton: true });
		this.setCurrentRouteConfig('consents', { reloadOnSearch: false, backButton: true });
		this.setCurrentRouteConfig('tallinn', { reloadOnSearch: false, hideFooter: true, isNoHeader: true, noOffsetBottom: true });
		this.setCurrentRouteConfig('corporate/customers/limitation', { reloadOnSearch: false });
		this.setCurrentRouteConfig('corporate-insurance', { showProfileHeader: true });
		this.setCurrentRouteConfig('dependents', { showProfileHeader: true });
		this.setCurrentRouteConfig('employees', { showProfileHeader: true });
		this.setCurrentRouteConfig('employee-surveys', { showProfileHeader: true });
		this.setCurrentRouteConfig('compliance', { showProfileHeader: true });
		this.setCurrentRouteConfig('compliance/:questionnaireRequestId/results', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('compliance/:questionnaireRequestId/action-plan', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('compliance-assessment-action/:role/:token', { hideFooter: true, isNoHeader: true });
		this.setCurrentRouteConfig('my-training', { showProfileHeader: true });
		this.setCurrentRouteConfig('my-training/overview', { showProfileHeader: true });
		this.setCurrentRouteConfig('my-training/module/:moduleId', { showProfileHeader: true });
		this.setCurrentRouteConfig('my-training/module/:moduleId/:sectionId', { showProfileHeader: true });
		this.setCurrentRouteConfig('my-training/quiz/:moduleId', { showProfileHeader: true });
		this.setCurrentRouteConfig('my-training/results/:moduleId', { showProfileHeader: true });
		this.setCurrentRouteConfig('my-training/certificate', { showProfileHeader: true });
		this.setCurrentRouteConfig('my-training/certificate', { showProfileHeader: true });
		this.setCurrentRouteConfig('', { reloadOnSearch: false, showFooterInMobile: true });
		this.setCurrentRouteConfig('dashboard', { showProfileHeader: true });
		this.setCurrentRouteConfig('insurance/:tabCode', { reloadOnSearch: false, noOffsetBottom: true });
		this.setCurrentRouteConfig('claim-request', { reloadOnSearch: false, noOffsetBottom: true });
		this.setCurrentRouteConfig('policy-settings', { reloadOnSearch: false, noOffsetBottom: true });
		this.setCurrentRouteConfig('invoices', { showProfileHeader: true });
		this.setCurrentRouteConfig('join-requests', { showProfileHeader: true });
		this.setCurrentRouteConfig('limits', { showProfileHeader: true });
		this.setCurrentRouteConfig('meditation', { reloadOnSearch: false });
		this.setCurrentRouteConfig('my/wellbeing/profile', { reloadOnSearch: false });
		this.setCurrentRouteConfig('prescription-list', { showProfileHeader: true, backButton: true, hideFooter: false, isNarrow: false });
		this.setCurrentRouteConfig('pre-visit', { showProfileHeader: true, backButton: true, hideFooter: true, isNarrow: false });
		this.setCurrentRouteConfig('pre-visit/insert-for-person', { showProfileHeader: true, backButton: true, hideFooter: true, isNarrow: false });
		this.setCurrentRouteConfig('pre-visit/insert-for-person-list', { showProfileHeader: true, backButton: true, hideFooter: true, isNarrow: false });
		this.setCurrentRouteConfig('pre-visit/mental-check', { backButton: true });
		this.setCurrentRouteConfig('pre-visit/record-ticket-for-person', { showProfileHeader: true, backButton: true, hideFooter: true, isNarrow: false });
		this.setCurrentRouteConfig('profile', { hideFooter: true });
		this.setCurrentRouteConfig('promo', { backButton: true });
		this.setCurrentRouteConfig('redirect-user', { reloadOnSearch: false });
		this.setCurrentRouteConfig('schedule/configure', { backButton: true, ofyVisible: true });
		this.setCurrentRouteConfig('settings', { backButton: true });
		this.setCurrentRouteConfig('specialist/:serviceId', { reloadOnSearch: false });
		this.setCurrentRouteConfig('sp-settings', { backButton: true });
		this.setCurrentRouteConfig('therapy-fund-wallets', { showProfileHeader: true });
		this.setCurrentRouteConfig('transactions', { showProfileHeader: true });
		this.setCurrentRouteConfig('wallet', { reloadOnSearch: true, backButton: true });
		this.setCurrentRouteConfig('toolkit', { showProfileHeader: true });
		this.setCurrentRouteConfig('toolkit/client/:id', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('toolkit/assessment/assign/:id', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('toolkit/assessment/preview/:id', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('toolkit/assign/:kind/:id', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('toolkit/preview/:kind/:id', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('my-exercises', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('my-exercises/resource/survey/:assignmentId/history', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('my-exercises/resource/:kind/:assignmentId', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('my-exercises/resource/:assignmentId', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('my-exercises/exercise/:id', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('my-exercises/survey/:id', { showProfileHeader: true, backButton: true });
		// Back-compat routes.
		this.setCurrentRouteConfig('my-toolkit', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('my-toolkit/exercise/:id', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('my-toolkit/survey/:id', { showProfileHeader: true, backButton: true });
		this.setCurrentRouteConfig('av-test', { hideFooter: true });
	}
	
	setPath(path, flag?, replaceUrl?, queryParams?) {
		var config = {};
		if (queryParams) {
			config['queryParams'] = queryParams;
			config['queryParamsHandling'] = '';
		}
		if (replaceUrl) {
			config['replaceUrl'] = true;
			return this.router.navigate(Array.isArray(path) ? path : [path], config);
		} else {		
			return this.router.navigate(Array.isArray(path) ? path : [path], config);
		}
	}
	
	setPathAndKeepQueryParams(path) {
		const currentQueryParams = this.routeQueryParams;
		this.router.navigate(Array.isArray(path) ? path : [path], { queryParams: currentQueryParams });
	}
	
	setQueryParams(json) {
		this.router.navigate([], { queryParams: json, queryParamsHandling: '' });
	}
	
	setQueryParam(name, value) {
		var asJson = {};
		asJson[name] = value;
		this.router.navigate([], { queryParams: asJson, queryParamsHandling: 'merge', replaceUrl: true });
	}
	
	clearQueryParamsDirty() {
		this.router.navigate([], { queryParams: {}, queryParamsHandling: '' });
	}
	
	getCurrentPath(): any {
		return this.getCurrentRoute();
	}
	
	getQueryParams() {
		return this.routeQueryParams;
	}
	
	getQueryParam(name) {
		return this.routeQueryParams[name];
	}
	
	goHomeAndReturnPath(sessionUser) {
		this.home(sessionUser, false);
		return this.getCurrentRoute();
	}
	
	goHome(sessionUser) {
		this.home(sessionUser, true);
		return this.getCurrentRoute();
	}
	
	goHomeAndKeepHistory(sessionUser) {
		return this.home(sessionUser, false);
	}
	
	home(sessionUser, replaceUrl?) {
		if (sessionUser // && this.angularStateHelperService.getGlobalProperty('isLoggedIn') TODO ANGULAR_2 why is this needed?
			) {
			if (sessionUser.businessUser) {
				if (sessionUser.businessUserType === 'SERVICE_PROVIDER') {
					if (sessionUser.service && sessionUser.service && sessionUser.service.status === 'ACTIVE') {
						return this.setPath('/bookings/upcoming', false, replaceUrl);
					} else {
						return this.setPath('/sp-settings', false, replaceUrl);
					}
				} else if (sessionUser.service && sessionUser.service.status === 'COMPLICATED') {
					if (sessionUser.businessUserType === 'BUSINESS_CLIENT') {
						return this.setPath('/settings', false, replaceUrl);
					} else if (sessionUser.businessUserType === 'SERVICE_OWNER') {
						return this.setPath('/settings', false, replaceUrl);
					}
				} else {
					return this.setPath('/employees', false, replaceUrl);
				}
			} else {
				return this.setPath('/', false, replaceUrl);
			}
		} else {
			return this.setPath('/login', false, replaceUrl);
		}
		return Promise.resolve(false);
	}
	
	getRouteParam(name) {
		return this.routeParams && this.routeParams[name]; // TODO ANGULAR_2: RE-FACTOR NEEDED? See video in https://www.samjulien.com/how-to-use-route-parameters-in-angular
	}
	
	getCurrentRouteConfigFor(name) {
		var _window: any = window;
		if (!_window.routeLocalsConfig) {
			this.initRoutingConfig();
		}
		var routePath: any = this.getCurrentRoute();
		if (routePath && routePath.originalPath) {
			routePath = routePath.originalPath;
		}
		var existingConfig: any = this.getCurrentRouteConfig(routePath);
		if (existingConfig) {
			return existingConfig.config[name];
		} else {
			return null;
		}
	}
	
	getCurrentRouteConfig(routePath) {
		var _window: any = window;
		if (!_window.routeLocalsConfig) {
			this.initRoutingConfig();
		}
		var jsonMatcher: any = { route: routePath };
		var routeConfigs: any = _window.routeLocalsConfig;
		var searchKey: any = Object.keys(jsonMatcher)[0];
		if (routeConfigs && routeConfigs.length > 0) {
			for(var i = 0; i < routeConfigs.length; i++) {
				if (routeConfigs[i].hasOwnProperty(searchKey) && routeConfigs[i][searchKey] == jsonMatcher[searchKey]) {
					return routeConfigs[i];
				}
			}
		}
		return null;
	}
	
	setCurrentRouteConfig(routePath, configJson) {
		var _window: any = window;
		if (!_window.routeLocalsConfig) {
			_window.routeLocalsConfig =[];
		}
		if (routePath && routePath.originalPath) {
			routePath = routePath.originalPath;
		}
		var existingConfig: any = this.getCurrentRouteConfig(routePath);
		if (!existingConfig) {
			var newRouteConfig: any = {};
			newRouteConfig['route'] = routePath;
			newRouteConfig['config'] = configJson;
			_window.routeLocalsConfig.push(newRouteConfig);
		} else {
			existingConfig.config = configJson;
		}
	}
	
	getCurrentRouteParam(name) {
		return this.routeParams[name];
	}
	
	getCurrentRoute() {
		return this.curRoute;
	}
	
	reloadRoute() {
		this.location.go(this.location.path());
		window.location.reload();
	}
	
}
